import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import ContentIndex from "../../components/content-index"
import ContentList from "../../components/content-list"
import useLinksTo from "../../hooks/use-links-to"

const BlogPostList = ({ action }) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulBlogPost(sort: { fields: publishedAt, order: DESC }) {
        edges {
          node {
            id
            title
            slug
            publishedAt
            author {
              name
            }
            image {
              title
              gatsbyImageData(
                layout: FULL_WIDTH
                sizes: "(max-width: 739px) 100vw, 50vw"
              )
            }
            categories {
              title
              slug
            }
          }
        }
      }
      allContentfulCategory(sort: { fields: title }) {
        edges {
          node {
            title
            slug
            blog_post {
              id
            }
          }
        }
      }
    }
  `)
  // make unpublished blog articles visible in development mode & invisible when deployed to production
  // TODO: add custom env variable here that might allow unpublished articles also in preview mode (if wanted)
  const posts = data.allContentfulBlogPost.edges
    .map(({ node }) =>
      process.env.NODE_ENV === "production" && !node?.publishedAt ? null : node
    )
    .filter(n => n)

  const categories = data.allContentfulCategory.edges
    .map(({ node }) => node)
    .filter(node => node.blog_post !== null)
  const { blogTo, getBlogCategoryTo, getPostLinkTo } = useLinksTo()

  return (
    <ContentIndex>
      <ContentList
        data={posts}
        filter
        categories={categories}
        allCategoryTo={blogTo}
        getCategoryTo={getBlogCategoryTo}
        render={post => (
          <ContentList.Item
            key={post.id}
            to={getPostLinkTo(post.slug)}
            title={post.title}
            subtitle={post.author && `By ${post.author.name}`}
            link={action}
            image={
              post.image && (
                <GatsbyImage
                  image={post.image.gatsbyImageData}
                  alt={post.image.title || post.title}
                />
              )
            }
          />
        )}
      />
    </ContentIndex>
  )
}

export default BlogPostList
